import { Link } from "react-router-dom";
import { Gift, Package, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

const Card = ({ className = "", children, testid }) => (
  <div data-testid={testid} className={`relative rounded-[28px] overflow-hidden border border-[#E6D7CC] ${className}`}>{children}</div>
);

export function Bento() {
  return (
    <section id="gifting" className="py-24 lg:py-36 bg-[#FAF7F2]" data-testid="gifting-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
        <Reveal className="max-w-2xl mb-14">
          <p className="overline text-[#6E504A]">The unboxing</p>
          <h2 className="font-display text-5xl sm:text-6xl mt-5 leading-[0.95]">Wrapped in pink, cream <span className="italic text-[#D88B94]">&amp; mocha.</span></h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[220px] gap-5 lg:gap-6">
          <Reveal className="md:col-span-7 md:row-span-2">
            <Card testid="bento-trio" className="h-full min-h-[340px] bg-[#F4EFE6]">
              <img src="/images/trio.jpg" alt="Golden Hour Trio gift box" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8 bg-gradient-to-t from-[#281715]/85 to-transparent text-[#FAF7F2] flex items-end justify-between gap-4">
                <div>
                  <p className="overline text-[#EBB1B6]">Golden Hour Trio</p>
                  <p className="font-display text-3xl mt-2">The gift that glows.</p>
                </div>
                <Link to="/product/golden-hour-trio" data-testid="bento-trio-link"
                  className="shrink-0 rounded-full bg-[#FAF7F2] text-[#281715] px-5 h-11 grid place-items-center text-sm hover:bg-[#EBB1B6] transition-colors duration-200">Shop set</Link>
              </div>
            </Card>
          </Reveal>
          <Reveal className="md:col-span-5" delay={0.1}>
            <Card testid="bento-palette" className="h-full bg-[#281715] text-[#FAF7F2] p-7 flex flex-col justify-between min-h-[220px]">
              <p className="overline text-[#EBB1B6]">Signature palette</p>
              <div className="flex items-end gap-3">
                {[["#EBB1B6", "Pink"], ["#FAF7F2", "Cream"], ["#7A4E43", "Mocha"]].map(([c, n]) => (
                  <div key={n} className="flex-1">
                    <div className="h-20 rounded-2xl" style={{ background: c }} />
                    <p className="text-sm mt-2 text-[#D9C4BC]">{n}</p>
                  </div>
                ))}
              </div>
            </Card>
          </Reveal>
          <Reveal className="md:col-span-5" delay={0.2}>
            <Card testid="bento-gift" className="h-full bg-[#EBB1B6] p-7 flex flex-col justify-between min-h-[220px]">
              <Gift className="w-7 h-7 text-[#281715]" strokeWidth={1.4} />
              <div>
                <p className="font-display text-3xl">Birthdays, holidays, graduations.</p>
                <p className="text-sm text-[#4A2E2B] mt-2">Every trio arrives in a keepsake box, ready to give.</p>
              </div>
            </Card>
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.1}>
            <Card testid="bento-packaging" className="h-full bg-[#F4EFE6] p-7 flex flex-col justify-between min-h-[200px]">
              <Package className="w-7 h-7" strokeWidth={1.4} />
              <p className="font-display text-2xl">Tissue, ribbon and a note — every order.</p>
            </Card>
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.15}>
            <Card testid="bento-gloss" className="h-full min-h-[220px]">
              <img src="/images/gloss.jpg" alt="Glasshouse Gloss on stone" className="absolute inset-0 w-full h-full object-cover object-[50%_40%]" loading="lazy" />
            </Card>
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.2}>
            <Card testid="bento-shine" className="h-full bg-[#FAF7F2] p-7 flex flex-col justify-between min-h-[200px]">
              <Sparkles className="w-7 h-7 text-[#D88B94]" strokeWidth={1.4} />
              <p className="font-display text-2xl">Affordable luxury, <span className="italic">everyday</span> confidence.</p>
            </Card>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
